import { Box, Typography, Button } from "@mui/material";

export const CalendarSection = () => {
  const handleCalendarClick = () => {
    window.open('/calendario-2026.pdf', '_blank');
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <img
        src="./images/calendario.png"
        alt="Calendário 2026 Ministério Verbo da Vida"
        onClick={handleCalendarClick}
        style={{
          maxWidth: '100%',
          height: 'auto',
          borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
          cursor: 'pointer',
          transition: 'transform 0.2s ease-in-out',
        }}
        onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
      />
    </Box>
  );
};
